const SHOW_ELEV8_CORE_PRICES = "show_elev8core_prices";

export { SHOW_ELEV8_CORE_PRICES };
//# sourceMappingURL=src-constants-featureFlags.js.map
